import 'core-js/stable';
import 'regenerator-runtime/runtime';

import {
  APP_INIT_ERROR,
  APP_READY,
  subscribe,
  initialize,
  mergeConfig,
  getConfig
} from '@edx/frontend-platform';
import {
  AppProvider,
  ErrorPage,
} from '@edx/frontend-platform/react';
import React from 'react';
import ReactDOM from 'react-dom';

import { UserMessagesProvider } from './generic/user-messages';
import initializeStore from './store';
import NoticesProvider from './generic/notices';
import PathFixesProvider from './generic/path-fixes';
import App from './App';
import LocalizationProvider from './LocalizationProvider';

import './index.scss';
import 'react-toastify/dist/ReactToastify.css';
import CookiePollLogout from './cookie-poll-logout';
import { inactiveRedirection302Middleware, logout401And403Middleware } from './utils/middlewares';
import { Helmet } from 'react-helmet';
import ReactGA from "react-ga4";

const reactGaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
if (reactGaId) {
  ReactGA.initialize(reactGaId);
}

subscribe(APP_READY, () => {
  ReactDOM.render(
    <>
      <AppProvider store={initializeStore()}>
        <CookiePollLogout />
        <LocalizationProvider>
          <PathFixesProvider>
            <NoticesProvider>
              <UserMessagesProvider>
                <Helmet>
                  <link rel="shortcut icon" href={`${getConfig()["FAVICON_URL"]}?ver=${Math.floor(Math.random() * 99)}`} type="image/x-icon" />
                  <link rel="apple-touch-icon" href={`${getConfig()["FAVICON_URL"]}?ver=${Math.floor(Math.random() * 99)}`} />
                  {/* Shortcut tiles */}
                  <link rel="apple-touch-icon" href={`${getConfig()["FAVICON_URL"]}?ver=${Math.floor(Math.random() * 99)}`} sizes="57x57" />
                  <link rel="apple-touch-icon" href={`${getConfig()["FAVICON_URL"]}?ver=${Math.floor(Math.random() * 99)}`} sizes="72x72" />
                  <link rel="apple-touch-icon" href={`${getConfig()["FAVICON_URL"]}?ver=${Math.floor(Math.random() * 99)}`} sizes="76x76" />
                  <link rel="apple-touch-icon" href={`${getConfig()["FAVICON_URL"]}?ver=${Math.floor(Math.random() * 99)}`} sizes="114x114" />
                  <link rel="apple-touch-icon" href={`${getConfig()["FAVICON_URL"]}?ver=${Math.floor(Math.random() * 99)}`} sizes="120x120" />
                  <link rel="apple-touch-icon" href={`${getConfig()["FAVICON_URL"]}?ver=${Math.floor(Math.random() * 99)}`} sizes="144x144" />
                  <link rel="apple-touch-icon" href={`${getConfig()["FAVICON_URL"]}?ver=${Math.floor(Math.random() * 99)}`} sizes="152x152" />
                </Helmet>
                <App />
              </UserMessagesProvider>
            </NoticesProvider>
          </PathFixesProvider>
        </LocalizationProvider>
      </AppProvider>
    </>,
    document.getElementById('root'),
  );
});

subscribe(APP_INIT_ERROR, (error) => {
  ReactDOM.render(
    <ErrorPage message={error.message} />,
    document.getElementById('root'),
  );
});

initialize({
  handlers: {
    config: () => {
      mergeConfig(
        {
          CONTACT_URL: process.env.CONTACT_URL || null,
          CREDENTIALS_BASE_URL: process.env.CREDENTIALS_BASE_URL || null,
          CREDIT_HELP_LINK_URL: process.env.CREDIT_HELP_LINK_URL || null,
          DISCUSSIONS_MFE_BASE_URL:
            process.env.DISCUSSIONS_MFE_BASE_URL || null,
          ENTERPRISE_LEARNER_PORTAL_HOSTNAME:
            process.env.ENTERPRISE_LEARNER_PORTAL_HOSTNAME || null,
          ENABLE_JUMPNAV: process.env.ENABLE_JUMPNAV || null,
          ENABLE_NOTICES: process.env.ENABLE_NOTICES || null,
          INSIGHTS_BASE_URL: process.env.INSIGHTS_BASE_URL || null,
          SEARCH_CATALOG_URL: process.env.SEARCH_CATALOG_URL || null,
          SOCIAL_UTM_MILESTONE_CAMPAIGN:
            process.env.SOCIAL_UTM_MILESTONE_CAMPAIGN || null,
          STUDIO_BASE_URL: process.env.STUDIO_BASE_URL || null,
          SUPPORT_URL: process.env.SUPPORT_URL || null,
          SUPPORT_URL_CALCULATOR_MATH:
            process.env.SUPPORT_URL_CALCULATOR_MATH || null,
          SUPPORT_URL_ID_VERIFICATION:
            process.env.SUPPORT_URL_ID_VERIFICATION || null,
          SUPPORT_URL_VERIFIED_CERTIFICATE:
            process.env.SUPPORT_URL_VERIFIED_CERTIFICATE || null,
          TERMS_OF_SERVICE_URL: process.env.TERMS_OF_SERVICE_URL || null,
          TWITTER_HASHTAG: process.env.TWITTER_HASHTAG || null,
          TWITTER_URL: process.env.TWITTER_URL || null,
          LEGACY_THEME_NAME: process.env.LEGACY_THEME_NAME || null,
          DASHBOARD_MFE_BASE_URL:
            process.env.REACT_APP_DASHBOARD_BASE_URL || null,
          LEARNING_MFE_BASE_URL:
            process.env.REACT_APP_LEARNING_BASE_URL || null,
          PLATFORM_NAME: process.env.REACT_APP_PLATFORM_NAME || null,
          PANEL_BASE_URL: process.env.REACT_APP_PANEL_URL || null,
          SPEECHCRAFT_MFE_BASE_URL:
            process.env.REACT_APP_SPEECHCRAFT_BASE_URL || null,
          SPEECHCRAFT_LOGO_URL:
            process.env.REACT_APP_SPEECHCRAFT_LOGO_URL || null,
          PATHWAYS_LOGO_URL: process.env.REACT_APP_PATHWAYS_LOGO_URL || null,
          LOGOUT_URL: process.env.REACT_APP_LOGOUT_URL || null,
          LIBRARY_BASE_URL: process.env.REACT_APP_LIBRARY_BASE_URL || null,
          LOGIN_URL: process.env.REACT_APP_LOGIN_URL || null,
        },
        'LearnerAppConfig',
      );
    },
  },
  messages: [
    // appMessages,
    // footerMessages,
    // headerMessages,
  ],
  authMiddleware: [inactiveRedirection302Middleware, logout401And403Middleware],
});
